import { render, staticRenderFns } from "./ComposerAttachments.vue?vue&type=template&id=b2323b98&scoped=true"
import script from "./ComposerAttachments.vue?vue&type=script&lang=js"
export * from "./ComposerAttachments.vue?vue&type=script&lang=js"
import style0 from "./ComposerAttachments.vue?vue&type=style&index=0&id=b2323b98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2323b98",
  null
  
)

export default component.exports